import { Injectable } from '@angular/core';
import { FieldConfig } from '../entity/fieldconfig/fieldconfig';
import { QueryCondition } from '../entity/querycondition';
// import { SolutionService } from './solution.service';
import { EnumType } from '../entity/controltype/dropdownlist/enumtype';
import { EnumBoolValue } from '../entity/controltype/dropdownlist/boolenumvalue';
import { EnumIntegerValue } from '../entity/controltype/dropdownlist/integerenumvalue';
import { EnumStringValue } from '../entity/controltype/dropdownlist/stringenumvalue';
import { ControlType } from '../entity/controltype';
import { CompareType } from '../entity/comparetype';
import { DropDownListValue } from '../entity/conditionvalue/dropdownlistvalue';
import { ValueType } from '../entity/valuetype';
import { RelationType } from '../entity/relationtype';
import { NumberRangeValue } from '../entity/conditionvalue/numberrangevaue';
import { DateRangeValue } from '../entity/conditionvalue/daterangevalue';
import { TextValue } from '../entity/conditionvalue/textvalue';
import { DropDownControl } from '../entity/controltype/dropdownlist/dropdowncontrol';
import { HelpValue } from '../entity/conditionvalue/helpvalue';
import { CheckboxGroupControl } from '../entity/controltype/checkbox/checkboxcontrol';
import { SearchValue } from '../entity/conditionvalue/searchvalue';
import { CheckboxGroupValue } from '../entity/conditionvalue/checkboxgroupvalue';
import { DateValue } from '../entity/conditionvalue/datevalue';
import { CheckboxIEnumValue, CheckboxEnumValue } from '../entity/controltype/checkbox/ienumvalue';
import { DateRangeTimeValue } from '../entity/conditionvalue/daterangetimevalue';

@Injectable()
export class ConvertorService {

    constructor() { }
    // private solutionservice:SolutionService
    /**
    * 获取已选择的字段配置
    * @param selectedConditions 
    */
    getFeildConfigs(selectedConditions: Array<QueryCondition>) {
        let fieldsConfigs = new Array<FieldConfig>();
        if (!selectedConditions || selectedConditions.length <= 0) {
            return fieldsConfigs;
        }
        else {
            selectedConditions.forEach(condition => {
                let fieldConfig = new FieldConfig();
                fieldConfig.id = condition.id;
                fieldConfig.labelCode = condition.fieldCode;
                fieldConfig.name = condition.fieldName;
                fieldConfig.control = condition.control;
                fieldsConfigs.push(fieldConfig);
            });
        }
        return fieldsConfigs;
    }

    getSelectedFieldConditions(fileds: Array<FieldConfig>, selectedFieldConditions: Array<QueryCondition>) {
        // console.log(selectedFieldConditions);
        let tempSelectedFieldConditions = new Array<QueryCondition>();
        tempSelectedFieldConditions = this.arrayClone(selectedFieldConditions);
        selectedFieldConditions = new Array<QueryCondition>();
        fileds.forEach(filed => {
            filed.control = this.getDropListEnumValues(filed.control as DropDownControl);
            // filed.control = this.getCheckGroupEnumValues(filed.control as CheckboxGroupControl);
            if (tempSelectedFieldConditions.length > 0) {
                let tempIndex = tempSelectedFieldConditions.findIndex(x => x.id == filed.id);
                if (tempIndex != (-1)) {
                    tempSelectedFieldConditions[tempIndex].visible = filed.visible !== false;
                    selectedFieldConditions.push(tempSelectedFieldConditions[tempIndex]);
                }
                else {
                    selectedFieldConditions = this.getNewFieldConditions(filed, selectedFieldConditions);
                }
            } else {
                selectedFieldConditions = this.getNewFieldConditions(filed, selectedFieldConditions);
            }

        });
        return selectedFieldConditions;
    }

    private getDropListEnumValues(control: DropDownControl): DropDownControl {
        if (control.valueType == EnumType.BoolType) {
            let enumValues = new Array<EnumBoolValue>();
            control.enumValues.forEach(element => {
                enumValues.push(Object.assign(new EnumBoolValue(), element));
            });
            control.enumValues = enumValues;
        }
        else if (control.valueType == EnumType.IntType) {
            let enumValues = new Array<EnumIntegerValue>();
            control.enumValues.forEach(element => {
                enumValues.push(Object.assign(new EnumIntegerValue(), element));
            });
            control.enumValues = enumValues;
        }
        else if (control.valueType == EnumType.StringType) {
            let enumValues = new Array<EnumStringValue>();
            control.enumValues.forEach(element => {
                enumValues.push(Object.assign(new EnumStringValue(), element));
            });
            control.enumValues = enumValues;
        }
        return control;
    }

    private getCheckGroupEnumValues(control: CheckboxGroupControl): CheckboxGroupControl {
        let enumValues = new Array<CheckboxIEnumValue>();
        control.enumValues.forEach(element => {
            enumValues.push(Object.assign(new CheckboxEnumValue(), element));
        });
        control.enumValues = enumValues;
        return control;
    }

    public getNewFieldConditions(filed: FieldConfig, selectedFieldConditions: Array<QueryCondition>) {
        let selectedFieldCondition = new QueryCondition();
        selectedFieldCondition.visible = filed.visible !== false;
        selectedFieldCondition.shown = true;

        if (filed.control.getControlType() == ControlType.Text) {
            selectedFieldConditions = this.getTextValueFieldCondition(selectedFieldCondition, filed, selectedFieldConditions);
        }
        else if (filed.control.getControlType() == ControlType.DateRange) {
            selectedFieldConditions = this.getDateRangeValueFieldCondition(selectedFieldCondition, filed, selectedFieldConditions);
        }
        else if (filed.control.getControlType() == ControlType.DateRangeTime) {
            selectedFieldConditions = this.getDateRangeTimeValueFieldCondition(selectedFieldCondition, filed, selectedFieldConditions);
        }
        else if (filed.control.getControlType() == ControlType.MonthRange) {
            selectedFieldConditions = this.getDateRangeValueFieldCondition(selectedFieldCondition, filed, selectedFieldConditions);
        }
        else if (filed.control.getControlType() == ControlType.YearRange) {
            selectedFieldConditions = this.getDateRangeValueFieldCondition(selectedFieldCondition, filed, selectedFieldConditions);
        }
        else if (filed.control.getControlType() == ControlType.NumberRange) {
            selectedFieldConditions = this.getNumberRangeValueFieldCondition(selectedFieldCondition, filed, selectedFieldConditions);
        }
        else if (filed.control.getControlType() == ControlType.Help) {
            selectedFieldConditions = this.getSmartHelpValueFieldCondition(selectedFieldCondition, filed, selectedFieldConditions);
        }
        else if (filed.control.getControlType() == ControlType.DropDown) {
            selectedFieldConditions = this.getDropDownListValueFieldCondition(selectedFieldCondition, filed, selectedFieldConditions);
        }
        else if (filed.control.getControlType() == ControlType.Search) {
            selectedFieldConditions = this.getSearchValueFieldCondition(selectedFieldCondition, filed, selectedFieldConditions);
        }
        else if (filed.control.getControlType() == ControlType.Date) {
            selectedFieldConditions = this.getDateValueFieldCondition(selectedFieldCondition, filed, selectedFieldConditions);
        }
        else if (filed.control.getControlType() == ControlType.Year) {
            selectedFieldConditions = this.getDateValueFieldCondition(selectedFieldCondition, filed, selectedFieldConditions);
        }
        else if (filed.control.getControlType() == ControlType.Month) {
            selectedFieldConditions = this.getDateValueFieldCondition(selectedFieldCondition, filed, selectedFieldConditions);
        }
        else if (filed.control.getControlType() == ControlType.CheckboxGroup) {
            selectedFieldConditions = this.getCheckboxGroupValueFieldCondition(selectedFieldCondition, filed, selectedFieldConditions);
        }
        else if (filed.control.getControlType() == ControlType.Radio) {
            selectedFieldConditions = this.getRadioValueFieldCondition(selectedFieldCondition, filed, selectedFieldConditions);
        }
        else if (filed.control.getControlType() == ControlType.InputGroup) {
            selectedFieldConditions = this.getInputGroupValueFieldCondition(selectedFieldCondition, filed, selectedFieldConditions);
        }
        else if (filed.control.getControlType() == ControlType.ComboLookUp) {
            selectedFieldConditions = this.getSmartHelpValueFieldCondition(selectedFieldCondition, filed, selectedFieldConditions);
        }
        return selectedFieldConditions;
    }

    private getDropDownListValueFieldCondition(selectedFieldCondition: QueryCondition, filed: FieldConfig, selectedFieldConditions: Array<QueryCondition>) {
        selectedFieldCondition.id = filed.id;
        selectedFieldCondition.fieldCode = filed.labelCode;
        selectedFieldCondition.placeHolder = filed.placeHolder;
        selectedFieldCondition.fieldName = filed.name;
        selectedFieldCondition.compareType = CompareType.Equal;
        selectedFieldCondition.valueType = ValueType.Value;
        selectedFieldCondition.value = filed.value;
        selectedFieldCondition.relationType = RelationType.And;
        selectedFieldCondition.control = filed.control;
        this.getDropListEnumValues(selectedFieldCondition.control as DropDownControl);
        selectedFieldConditions.push(selectedFieldCondition);
        return selectedFieldConditions;
    }

    private getCheckboxGroupValueFieldCondition(selectedFieldCondition: QueryCondition, filed: FieldConfig, selectedFieldConditions: Array<QueryCondition>) {
        selectedFieldCondition.id = filed.id;
        selectedFieldCondition.fieldCode = filed.labelCode;
        selectedFieldCondition.placeHolder = filed.placeHolder;
        selectedFieldCondition.fieldName = filed.name;
        selectedFieldCondition.compareType = CompareType.Equal;
        selectedFieldCondition.valueType = ValueType.Value;
        selectedFieldCondition.value = filed.value;
        selectedFieldCondition.relationType = RelationType.And;
        selectedFieldCondition.control = filed.control;
        this.getCheckGroupEnumValues(selectedFieldCondition.control as CheckboxGroupControl);
        selectedFieldConditions.push(selectedFieldCondition);
        return selectedFieldConditions;
    }

    private getRadioValueFieldCondition(selectedFieldCondition: QueryCondition, filed: FieldConfig, selectedFieldConditions: Array<QueryCondition>) {
        selectedFieldCondition.id = filed.id;
        selectedFieldCondition.fieldCode = filed.labelCode;
        selectedFieldCondition.placeHolder = filed.placeHolder;
        selectedFieldCondition.fieldName = filed.name;
        selectedFieldCondition.compareType = CompareType.Equal;
        selectedFieldCondition.valueType = ValueType.Value;
        selectedFieldCondition.value = filed.value;
        selectedFieldCondition.relationType = RelationType.And;
        selectedFieldCondition.control = filed.control;
        this.getCheckGroupEnumValues(selectedFieldCondition.control as CheckboxGroupControl);
        selectedFieldConditions.push(selectedFieldCondition);
        return selectedFieldConditions;
    }

    private getSmartHelpValueFieldCondition(selectedFieldCondition: QueryCondition, filed: FieldConfig, selectedFieldConditions: Array<QueryCondition>) {
        selectedFieldCondition.id = filed.id;
        selectedFieldCondition.fieldCode = filed.labelCode;
        selectedFieldCondition.placeHolder = filed.placeHolder;
        selectedFieldCondition.fieldName = filed.name;
        selectedFieldCondition.compareType = CompareType.Equal;
        selectedFieldCondition.valueType = ValueType.Value;
        selectedFieldCondition.value = filed.value;
        selectedFieldCondition.relationType = RelationType.And;
        selectedFieldCondition.control = filed.control;
        selectedFieldConditions.push(selectedFieldCondition);
        return selectedFieldConditions;
    }

    private getNumberRangeValueFieldCondition(selectedFieldCondition: QueryCondition, filed: FieldConfig, selectedFieldConditions: Array<QueryCondition>) {
        selectedFieldCondition.id = filed.id;
        selectedFieldCondition.fieldCode = filed.labelCode;
        selectedFieldCondition.placeHolder = filed.placeHolder;
        selectedFieldCondition.beginPlaceHolder = filed.beginPlaceHolder;
        selectedFieldCondition.endPlaceHolder = filed.endPlaceHolder;
        selectedFieldCondition.fieldName = filed.name;
        selectedFieldCondition.compareType = CompareType.BetWeen;
        selectedFieldCondition.valueType = ValueType.Value;
        selectedFieldCondition.value = filed.value;
        selectedFieldCondition.relationType = RelationType.And;
        selectedFieldCondition.control = filed.control;
        selectedFieldConditions.push(selectedFieldCondition);
        return selectedFieldConditions;
    }

    private getDateRangeValueFieldCondition(selectedFieldCondition: QueryCondition, filed: FieldConfig, selectedFieldConditions: Array<QueryCondition>) {
        selectedFieldCondition.id = filed.id;
        selectedFieldCondition.fieldCode = filed.labelCode;
        selectedFieldCondition.placeHolder = filed.placeHolder;
        selectedFieldCondition.beginPlaceHolder = filed.beginPlaceHolder;
        selectedFieldCondition.endPlaceHolder = filed.endPlaceHolder;
        selectedFieldCondition.fieldName = filed.name;
        selectedFieldCondition.compareType = CompareType.BetWeen;
        selectedFieldCondition.valueType = ValueType.Value;
        selectedFieldCondition.value = filed.value;
        selectedFieldCondition.relationType = RelationType.And;
        selectedFieldCondition.control = filed.control;
        selectedFieldConditions.push(selectedFieldCondition);
        return selectedFieldConditions;
    }

    private getDateRangeTimeValueFieldCondition(selectedFieldCondition: QueryCondition, filed: FieldConfig, selectedFieldConditions: Array<QueryCondition>) {
        selectedFieldCondition.id = filed.id;
        selectedFieldCondition.fieldCode = filed.labelCode;
        selectedFieldCondition.placeHolder = filed.placeHolder;
        selectedFieldCondition.fieldName = filed.name;
        selectedFieldCondition.compareType = CompareType.BetWeen;
        selectedFieldCondition.valueType = ValueType.Value;
        selectedFieldCondition.value = filed.value;
        selectedFieldCondition.relationType = RelationType.And;
        selectedFieldCondition.control = filed.control;
        selectedFieldConditions.push(selectedFieldCondition);
        return selectedFieldConditions;
    }

    private getTextValueFieldCondition(selectedFieldCondition: QueryCondition, filed: FieldConfig, selectedFieldConditions: Array<QueryCondition>) {
        selectedFieldCondition.id = filed.id;
        selectedFieldCondition.fieldCode = filed.labelCode;
        selectedFieldCondition.placeHolder = filed.placeHolder;
        selectedFieldCondition.fieldName = filed.name;
        selectedFieldCondition.compareType = CompareType.Equal;
        selectedFieldCondition.valueType = ValueType.Value;
        selectedFieldCondition.value = filed.value;
        selectedFieldCondition.relationType = RelationType.And;
        selectedFieldCondition.control = filed.control;
        selectedFieldConditions.push(selectedFieldCondition);
        return selectedFieldConditions;
    }
    private getInputGroupValueFieldCondition(selectedFieldCondition: QueryCondition, filed: FieldConfig, selectedFieldConditions: Array<QueryCondition>) {
        selectedFieldCondition.id = filed.id;
        selectedFieldCondition.fieldCode = filed.labelCode;
        selectedFieldCondition.placeHolder = filed.placeHolder;
        selectedFieldCondition.fieldName = filed.name;
        selectedFieldCondition.compareType = CompareType.Equal;
        selectedFieldCondition.valueType = ValueType.Value;
        selectedFieldCondition.value = filed.value;
        selectedFieldCondition.relationType = RelationType.And;
        selectedFieldCondition.control = filed.control;
        selectedFieldConditions.push(selectedFieldCondition);
        return selectedFieldConditions;
    }

    private getDateValueFieldCondition(selectedFieldCondition: QueryCondition, filed: FieldConfig, selectedFieldConditions: Array<QueryCondition>) {
        selectedFieldCondition.id = filed.id;
        selectedFieldCondition.fieldCode = filed.labelCode;
        selectedFieldCondition.placeHolder = filed.placeHolder;
        selectedFieldCondition.fieldName = filed.name;
        selectedFieldCondition.compareType = CompareType.Equal;
        selectedFieldCondition.valueType = ValueType.Value;
        selectedFieldCondition.value = filed.value;
        selectedFieldCondition.relationType = RelationType.And;
        selectedFieldCondition.control = filed.control;
        selectedFieldConditions.push(selectedFieldCondition);
        return selectedFieldConditions;
    }

    private getSearchValueFieldCondition(selectedFieldCondition: QueryCondition, filed: FieldConfig, selectedFieldConditions: Array<QueryCondition>) {
        selectedFieldCondition.id = filed.id;
        selectedFieldCondition.fieldCode = filed.labelCode;
        selectedFieldCondition.placeHolder = filed.placeHolder;
        selectedFieldCondition.fieldName = filed.name;
        selectedFieldCondition.compareType = CompareType.Equal;
        selectedFieldCondition.valueType = ValueType.Value;
        selectedFieldCondition.value = filed.value;
        selectedFieldCondition.relationType = RelationType.And;
        selectedFieldCondition.control = filed.control;
        selectedFieldConditions.push(selectedFieldCondition);
        return selectedFieldConditions;
    }

    private arrayClone(input: Array<any>): Array<any> {
        let result = new Array<any>();
        if (input && input.length > 0) {
            input.forEach(element => {
                result.push(Object.assign({}, element));
            });
        }
        return result;
    }
}